import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function AccessDenied() {
  const navigate = useNavigate()
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow p-6 text-center">
        <h2 className="text-2xl font-semibold mb-2">Access Denied</h2>
        <p className="text-gray-600 mb-4">Your email is not registered for this portal. Please contact your administrator to request access.</p>
        <div className="flex justify-center gap-3">
          <button onClick={() => navigate('/')} className="px-4 py-2 rounded bg-blue-600 text-white">Back to Login</button>
        </div>
      </div>
    </div>
  )
}
